module.exports = "/wp-content/plugins/farmacy/assets/js/images/cat_edible_label-0bbe884977fa029aea4a653d34de4cb2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-thumb/img/cat_edible_label.png
 ** module id = 154
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 17 22 25 26
 **/